import { axios } from '@/utils/request'

const api = {
  cateTreeList: '/badminapi/goods/cateTreeList',
  goodsEdit: '/badminapi/ticketgoods/goodsEdit',
  goodsAdd: '/badminapi/ticketgoods/goodsAdd',
  goodsContentEdit: '/badminapi/ticketgoods/goodsContentEdit',
  goodsDetail: '/badminapi/ticketgoods/goodsDetail',
  goodsList: '/badminapi/ticketgoods/goodsList',
  setGoodsStatus: '/badminapi/ticketgoods/setGoodsStatus',
  setGoodsAllStatus: '/badminapi/ticketgoods/setGoodsAllStatus',
  goodsDelete: '/badminapi/ticketgoods/goodsDelete',
  goodsRankEdit: '/badminapi/ticketgoods/goodsRankEdit',
  getShopOptions: '/badminapi/businessShop/shopOptions',
  getLineOptions: '/badminapi/businessLine/lineOptions',
  onHandleRecom: '/badminapi/ticketgoods/onHandleRecom',
  NotHandleRecom: '/badminapi/ticketgoods/NotHandleRecom',
  hotelRoomDetail: '/badminapi/ticketgoods/hotelRoomDetail',
  roomAdd: '/badminapi/ticketgoods/roomAdd',
  roomEdit: '/badminapi/ticketgoods/roomEdit',
  stockSetInc: '/badminapi/ticketgoods/stockSetInc',
}

export default api

export function getGoodsList(parameter) {
  return axios({
    url: api.goodsList,
    method: 'get',
    params: parameter
  })
}
export function getGoodsDetail(parameter) {
  return axios({
    url: api.goodsDetail,
    method: 'get',
    params: parameter
  })
}

export function hotelRoomDetail(parameter) {
  return axios({
    url: api.hotelRoomDetail,
    method: 'get',
    params: parameter
  })
}

export function roomAdd(parameter) {
  return axios({
    url: api.roomAdd,
    method: 'post',
    data: parameter
  })
}
export function roomEdit(parameter) {
  return axios({
    url: api.roomEdit,
    method: 'post',
    data: parameter
  })
}
export function getCateTreeList(parameter) {
  return axios({
    url: api.cateTreeList,
    method: 'get',
    params: parameter
  })
}
export function getCateList(parameter) {
  return axios({
    url: api.cateList,
    method: 'get',
    params: parameter
  })
}
export function addGoods(parameter) {
  return axios({
    url: api.goodsAdd,
    method: 'post',
    data: parameter
  })
}
export function editGoods(parameter) {
  return axios({
    url: api.goodsEdit,
    method: 'post',
    data: parameter
  })
}
export function addCate(parameter) {
  return axios({
    url: api.cateAdd,
    method: 'post',
    data: parameter
  })
}
export function editCate(parameter) {
  return axios({
    url: api.cateEdit,
    method: 'post',
    data: parameter
  })
}
export function deleteCate(parameter) {
  return axios({
    url: api.cateDelete,
    method: 'post',
    data: parameter
  })
}
export function getCateDetail(parameter) {
  return axios({
    url: api.cateDetail,
    method: 'get',
    params: parameter
  })
}
export function getAttrList(parameter) {
  return axios({
    url: api.attrList,
    method: 'get',
    params: parameter
  })
}
export function getFieldList(parameter) {
  return axios({
    url: api.fieldList,
    method: 'get',
    params: parameter
  })
}
export function skuFieldAdd(parameter) {
  return axios({
    url: api.skuFieldAdd,
    method: 'post',
    data: parameter
  })
}
export function skuAttrAdd(parameter) {
  return axios({
    url: api.skuAttrAdd,
    method: 'post',
    data: parameter
  })
}
export function skuAttrDelete(parameter) {
  return axios({
    url: api.skuAttrDelete,
    method: 'post',
    data: parameter
  })
}
export function skuFieldDelete(parameter) {
  return axios({
    url: api.skuFieldDelete,
    method: 'post',
    data: parameter
  })
}


export function skuDetail(parameter) {
  return axios({
    url: api.skuDetail,
    method: 'get',
    params: parameter
  })
}
export function stockSetInc(parameter) {
  return axios({
    url: api.stockSetInc,
    method: 'post',
    data: parameter
  })
}
export function skuEdit(parameter) {
  return axios({
    url: api.skuEdit,
    method: 'post',
    data: parameter
  })
}
export function goodsContentEdit(parameter) {
  return axios({
    url: api.goodsContentEdit,
    method: 'post',
    data: parameter
  })
}
export function setGoodsAllStatus(parameter) {
  return axios({
    url: api.setGoodsAllStatus,
    method: 'post',
    data: parameter
  })
}
export function setGoodsStatus(parameter) {
  return axios({
    url: api.setGoodsStatus,
    method: 'post',
    data: parameter
  })
}
export function deleteGoods(parameter) {
  return axios({
    url: api.goodsDelete,
    method: 'post',
    data: parameter
  })
}
export function setGoodsRank(parameter) {
  return axios({
    url: api.goodsRankEdit,
    method: 'post',
    data: parameter
  })
}


export function sellerRewardSetting(parameter) {
  return axios({
    url: api.sellerRewardSetting,
    method: 'post',
    data: parameter
  })
}

export function getSellerRewardSetting(parameter) {
  return axios({
    url: api.getSellerRewardSetting,
    method: 'get',
    params: parameter
  })
}



export function dealtownRewardSetting(parameter) {
  return axios({
    url: api.dealtownRewardSetting,
    method: 'post',
    data: parameter
  })
}

export function getDealtownRewardSetting(parameter) {
  return axios({
    url: api.getDealtownRewardSetting,
    method: 'get',
    params: parameter
  })
}
export function getShopOptions(parameter) {
  return axios({
    url: api.getShopOptions,
    method: 'get',
    params: parameter
  })
}
export function getLineOptions(parameter) {
  return axios({
    url: api.getLineOptions,
    method: 'get',
    params: parameter
  })
}
export function onHandleRecom(parameter) {
  return axios({
    url: api.onHandleRecom,
    method: 'post',
    params: parameter
  })
}
export function NotHandleRecom(parameter) {
  return axios({
    url: api.NotHandleRecom,
    method: 'post',
    params: parameter
  })
}


